const LearningSuiteIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.85 17.21H3.61C2.17 17.21 1 18.38 1 19.82M1 19.82C1 21.26 2.17 22.43 3.61 22.43H17.5C18.25 22.43 18.85 21.82 18.85 21.08V2.35C18.85 1.6 18.24 1 17.5 1H3.61C2.17 1 1 2.17 1 3.61V19.82Z"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M10.9707 1V6.52C10.9707 6.87 11.3907 7.04 11.6307 6.8L12.9707 5.46C13.1207 5.31 13.3707 5.31 13.5207 5.46L14.9107 6.85C15.1607 7.1 15.5707 6.92 15.5707 6.57V1"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default LearningSuiteIcon;
